import { gql } from '@apollo/client'

export const GET_ALL_FORM_FIELDS_TYPES = gql`
  query GetAllFormFieldTypes {
    getAllFormFieldTypes {
      rows {
        id
        name
        description
        type
      }
      count
    }
  }
`
